import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDone = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7392_188737)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.15625 11.7778C3.15625 7.35957 6.73797 3.77734 11.1562 3.77734C15.5745 3.77734 19.1562 7.35957 19.1562 11.7778C19.1562 16.1961 15.5745 19.7783 11.1562 19.7783C6.73797 19.7783 3.15625 16.1961 3.15625 11.7778Z",
			fill: "#1BDB5E"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7127 8.50383C16.1032 8.89435 16.1032 9.52752 15.7127 9.91804L10.5801 15.0507C10.1895 15.4412 9.55638 15.4412 9.16586 15.0507L6.59953 12.4844C6.20901 12.0938 6.20901 11.4607 6.59953 11.0702C6.99006 10.6796 7.62322 10.6796 8.01375 11.0702L9.87297 12.9294L14.2985 8.50383C14.689 8.11331 15.3222 8.11331 15.7127 8.50383Z",
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgDone);
export default ForwardRef;
